import { Button } from "primereact/button";
import { useSidebar } from "../contexts/SidebarContext";

export default function NotFoundPage() {
  const { toggleSidebar } = useSidebar();

  return (
    <div className="flex-container">
      <Button
        text
        size="small"
        severity="secondary"
        aria-label="Sidebar menu"
        icon="pi pi-bars"
        className="sidebar-toggle-button"
        onClick={toggleSidebar}
      />
      <h1 className="table-header">Page not found</h1>
    </div>
  );
}
